export const santizeBase64 = (base64?: string | null): string => {
  return (
    base64
      ?.replace('data:image/png;base64,', '')
      ?.replace('data:image/jpeg;base64,', '')
      ?.replace('data:application/pdf;base64,', '')
      ?.replace('application/vnd.openxmlformats-officedocument.wordprocessingml.document', '') ?? ''
  )
}
